// Count phrases worded the way the server words them
// (policies.CommaGrouped): grouped digits, and "1 row" beside
// "1,820 rows". Scripts that keep a server-rendered count up to date
// import these so the two read the same.

export function grouped(n) {
  return n.toLocaleString("en-US");
}

export function counted(n, noun, nouns) {
  return n === 1 ? `1 ${noun}` : `${grouped(n)} ${nouns}`;
}
